export default __webpack_public_path__ + "static/icon-33-3-9f0988c00a7477389137f33b323a0bcb.png";